import { useState } from "react";
import { motion } from "framer-motion";

const services = [
  {
    name: "Staff & Student ID Cards",
    description: "Production of staff and students identification cards.",
    image: "/images/id-cards.jpg",
  },
  {
    name: "Satchet Water Production",
    description: "Production and sale of satchet water.",
    image: "/images/satchet-water.jpg",
  },
  {
    name: "Cleaning & Fumigation",
    description: "Professional cleaning and fumigation services.",
    image: "/images/cleaning.jpg",
  },
  {
    name: "Computer Training",
    description: "Offering computer training programs.",
    image: "/images/computer-training.jpg",
  },
  {
    name: "Daily Needs Shop",
    description: "Operating a daily needs shop.",
    image: "/images/shop.jpg",
  },
  {
    name: "Car Wash",
    description: "Professional car wash services.",
    image: "/images/car-wash.jpg",
  },
];

const partners = [
  { name: "Partner 1", logo: "/images/partner1.png" },
  { name: "Partner 2", logo: "/images/partner2.png" },
  { name: "Partner 3", logo: "/images/partner3.png" },
  { name: "Partner 4", logo: "/images/partner4.png" },
];

const BidaPolyConsult = () => {
  const [selectedService, setSelectedService] = useState(null);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Banner */}
      <div
        className="relative h-[400px] bg-cover bg-center"
        style={{ backgroundImage: "url('/images/consult-hero.jpg')" }}
      >
        <div className="absolute inset-0 bg-blue-900 bg-opacity-70 flex items-center justify-center">
          <h1 className="text-4xl md:text-6xl font-extrabold text-white text-center">
            BidaPoly Consult Nig Ltd
          </h1>
        </div>
      </div>

      {/* Intro */}
      <div className="px-6 md:px-20 py-12">
        <h2 className="text-3xl font-bold mb-4">Welcome</h2>
        <p className="text-lg text-gray-700 mb-4">
          BidaPoly Consult Nig Ltd offers a range of professional services including staff and
          student ID card production, satchet water production, cleaning and fumigation services,
          computer training, a daily needs shop, and car wash services.
        </p>
        <p className="text-gray-600">
          We are committed to excellence, quality, and customer satisfaction.
        </p>
      </div>

      {/* Services Gallery */}
      <div className="px-6 md:px-20 py-12 bg-gray-100">
        <h2 className="text-3xl font-bold mb-8 text-center">Our Services</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="relative rounded-3xl overflow-hidden shadow-lg cursor-pointer group"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              onClick={() => setSelectedService(service)}
            >
              <motion.img
                src={service.image}
                alt={service.name}
                className="w-full h-64 object-cover rounded-3xl"
                whileHover={{ scale: 1.05, rotate: 1 }}
                transition={{ duration: 0.5 }}
              />
              <div className="absolute inset-0 bg-gradient-to-br from-blue-400 via-pink-400 to-purple-500 opacity-0 group-hover:opacity-60 transition-opacity duration-500 rounded-3xl flex flex-col justify-center items-center text-center p-6">
                <h3 className="text-white text-xl font-bold mb-2">{service.name}</h3>
                <p className="text-gray-100 text-sm">{service.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Partners & Collaborators */}
      <div className="px-6 md:px-20 py-12">
        <h2 className="text-3xl font-bold mb-6 text-center">Our Partners & Collaborators</h2>
        <p className="text-gray-700 mb-8 text-center">
          We proudly collaborate with leading institutions and organizations to enhance our services.
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 items-center justify-items-center">
          {partners.map((partner, index) => (
            <img
              key={index}
              src={partner.logo}
              alt={partner.name}
              className="h-16 object-contain"
            />
          ))}
        </div>
      </div>

      {/* Modal Popup */}
      {selectedService && (
        <motion.div
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setSelectedService(null)}
        >
          <motion.div
            className="bg-white rounded-3xl shadow-xl p-8 max-w-lg mx-4 relative"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ duration: 0.5 }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 text-2xl font-bold"
              onClick={() => setSelectedService(null)}
            >
              ×
            </button>
            <img
              src={selectedService.image}
              alt={selectedService.name}
              className="w-full h-64 object-cover rounded-2xl mb-4"
            />
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              {selectedService.name}
            </h2>
            <p className="text-gray-700 mb-4">{selectedService.description}</p>
            <p className="text-gray-500 text-sm">
              BidaPoly Consult Nig Ltd is committed to providing high-quality services for staff,
              students, and the community. Click outside to close this modal.
            </p>
          </motion.div>
        </motion.div>
      )}

      {/* Contact */}
      <div className="px-6 md:px-20 py-12 bg-blue-900 text-white text-center">
        <h2 className="text-3xl font-bold mb-4">Contact Us</h2>
        <p>Email: info@bidapolyconsult.com</p>
        <p>Phone: +234 800 123 4567</p>
        <p>Office Hours: Mon - Fri, 9am - 5pm</p>
      </div>
    </div>
  );
};

export default BidaPolyConsult;
